import styled from "styled-components";
import PlusImg from "../assets/Plus.svg";
import PfpDefault from "../assets/PfpDefault.svg";
import CaretDown from "../assets/Caret Down.svg";
import { NAV_BAR_HEIGHT } from "../contexts/Constants";
import { CreatePitchButton } from "../assets/Buttons";
import { useGlobalContext } from "../contexts/Constants";
import { PrimaryText } from "../assets/Texts";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Container = styled.nav`
  height: calc(${NAV_BAR_HEIGHT} - 1.5rem);
  width: calc(100% - 4rem);
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 2rem;
  background-color: #ffffff;
  @media (max-width: 767px) {
    width: calc(100vw - 2rem);
  }
`;

const NavLeft = styled.div`
  height: 100%;
`;

const NavRight = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const Page = styled.h2`
  display: flex;
  align-items: center;
  height: 100%;
`;

const UserBox = styled.div.attrs({ role: "button" })`
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const UserPfp = styled.img`
  height: 3rem;
  width: 3rem;
  border-radius: 1.5rem;
  margin-right: 0.5rem;
`;

const UserName = styled.div`
  height: 3rem;
  width: 3.125rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  margin: 0 0.5rem;
  @media (max-width: 880px) {
    display: none;
  }
`;
const DropdownMenu = styled.div`
  position: absolute;
  top: ${NAV_BAR_HEIGHT};
  right: 2rem;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 10rem;
  z-index: 1000;
`;

const DropdownItem = styled.div`
  padding: 0.75rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background-color: #f5f5f5;
  }

  &:first-child {
    border-radius: 0.5rem 0.5rem 0 0;
  }

  &:last-child {
    border-radius: 0 0 0.5rem 0.5rem;
  }
`;

const ButtonPlusImg = styled.img`
  padding: 0.1875rem;
`;

function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { setSelectedPageState, isMobile, setLoggedIn, userData } =
    useGlobalContext();
  const navigate = useNavigate();
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (isDropdownOpen && !target.closest('[role="button"]')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen]);

  return (
    <Container>
      <NavLeft>
        <Page>
          {isMobile ? (
            <>
              Simple<PrimaryText>Sales</PrimaryText>
            </>
          ) : (
            <>Dashboard</>
          )}
        </Page>
      </NavLeft>
      <NavRight>
        <CreatePitchButton onClick={() => setSelectedPageState("add")}>
          <ButtonPlusImg src={PlusImg} alt="Plus" />
          {!isMobile && "Create New Pitch"}
        </CreatePitchButton>{" "}
        <UserBox onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
          <UserPfp src={PfpDefault} alt="PFP" />
          <UserName>{userData.name}</UserName>
          <img src={CaretDown} alt="Down Caret" />
          {isDropdownOpen && (
            <DropdownMenu>
              <DropdownItem
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedPageState("viewAll");
                  setIsDropdownOpen(false);
                }}
              >
                Dashboard
              </DropdownItem>
              <DropdownItem
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedPageState("account");
                  setIsDropdownOpen(false);
                }}
              >
                Account
              </DropdownItem>
              <DropdownItem
                onClick={(e) => {
                  e.stopPropagation();
                  setLoggedIn({ status: false, token: "" });
                  localStorage.removeItem("token");
                  navigate("/login");
                  setIsDropdownOpen(false);
                }}
              >
                Logout
              </DropdownItem>
            </DropdownMenu>
          )}
        </UserBox>
      </NavRight>
    </Container>
  );
}

export default Navbar;
